import { render, staticRenderFns } from "./CategoryListWidget-CategoryCards.vue?vue&type=template&id=0579a93a&"
import script from "./CategoryListWidget-CategoryCards.vue?vue&type=script&lang=js&"
export * from "./CategoryListWidget-CategoryCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports